import React, { useState, useEffect, useRef } from 'react'
import Markdown from 'react-markdown'
import './InfoTooltip.scss'

const InfoTooltip = ({
  tooltipTitle,
  tooltipContent,
  additionalClickHandler = null,
  tooltipCloseText = '',
  children,
}) => {
  const [tooltipOpen, setTooltipOpen] = useState(false)
  const buttonRef = useRef(null)

  // so clicking OFF the tooltip closes it but ON the tooltip does nothing
  // (for mobile view)
  const stopPropagation = (e) => {
    e.stopPropagation()
  }

  // so clicking ON the tooltip icon puts the browser focus on it; required for onBlur to work
  // (default behavior for Chrome, but not FF or Safari)
  useEffect(() => {
    if (tooltipOpen === true) {
      buttonRef.current.focus()
    }
  }, [tooltipOpen])

  return (
    <div className="InfoTooltip">
      {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
      <button
        type="button"
        className="tooltip-icon"
        onClick={() => {
          setTooltipOpen(!tooltipOpen)
          if (additionalClickHandler) additionalClickHandler()
        }}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            setTooltipOpen(!tooltipOpen)
            if (additionalClickHandler) additionalClickHandler()
          }
        }}
        tabIndex="0"
        onBlur={() => {
          setTooltipOpen(false)
          if (additionalClickHandler) additionalClickHandler()
        }}
        ref={buttonRef}
      />

      {tooltipOpen && (
        // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
        <div
          className="modal-screen"
          onClick={() => {
            setTooltipOpen(false)
            if (additionalClickHandler) additionalClickHandler()
          }}
        >
          {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
          <div className="infobox" onClick={stopPropagation}>
            <h2 className="title">{tooltipTitle}</h2>

            {tooltipContent && <Markdown source={tooltipContent} />}
            {children}

            <button
              type="button"
              className="close"
              onClick={() => {
                setTooltipOpen(false)
                if (additionalClickHandler) additionalClickHandler()
              }}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  setTooltipOpen(false)
                  if (additionalClickHandler) additionalClickHandler()
                }
              }}
              tabIndex="0"
            >
              <span className="close-text">{tooltipCloseText}</span>
            </button>
          </div>
        </div>
      )}
    </div>
  )
}

export default InfoTooltip
